var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.marqueeDataList),function(log){return _c('MarqueeText',{key:log.id,attrs:{"text":log.text,"positionTop":log.positionTop,"isEnd":log.isEnd},on:{"marqueeEnd":function($event){return _vm.end(log.id)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }